import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import workflowProcessService from "services/Setup/Master/workflowProcessService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  source: {},
  destination: {},
  workflowProcessList: [],
  workflowList: undefined,
  status: undefined,
  flagData: undefined,
  workflowListOrigin: undefined,
};

export const getWorkflowProcessList = createAsyncThunk(
  "WorkflowProcess/getWorkflowProcessList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.getWorkflowProcessList();
      if (response.status === 200) {
        return response;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);

      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// Add Work Flow
export const addWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/addWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.addWorkflowProcess(data);
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End add Work FLow

// Do Return Work Flow
export const doReturnWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/doReturnWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.doReturnWorkflowProcess(
        data
      );
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End Do Return Work FLow

// Do Return Work Flow
export const rejectWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/rejectWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.rejectWorkflowProcess(data);
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End Do Return Work FLow

// Edit Work Flow
export const editWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/editWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.editWorkflowProcess(data);
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// Edit Work FLow
// Delete Work Flow
export const deleteWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/deleteWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.deleteWorkflowProcess(data);
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End Delete Work FLow

// Approve Work Flow
export const approveWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/approveWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.approveWorkflowProcess(
        data
      );
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End approve Work FLow

// Request Work Flow
export const requestWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/requestWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.requestWorkflowProcess(
        data
      );
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End Request Work FLow

// Request Work Flow
export const usSuspandWorkflowProcess = createAsyncThunk(
  "WorkflowProcess/usSuspandWorkflowProcess",
  async (data, { rejectWithValue }) => {
    try {
      const response = await workflowProcessService.requestWorkflowProcess(
        data
      );
      if (response) {
        return response;
      } else {
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// End Request Work FLow

export const lisWorkflow = createAsyncThunk(
  "WorkflowProcess/lisWorkflow",
  async (data, { rejectWithValue }) => {
    try {
      if (data.workflowProcessList.data && data.productTCDetail.data) {
        const productTCDetail = data.productTCDetail.data.productWorkflowItems;

        const workflowProcessList = data.workflowProcessList.data;
        const columnRight = [];
        const columnLeft = [];
        // const column = [];
        const filteredLeft = workflowProcessList.filter(
          (item) =>
            !productTCDetail.some(
              (filterItem) =>
                filterItem.productWorkflowProcess.code === item.code
            )
        );

        filteredLeft.map((itemResult) => {
          columnLeft.push({
            id: itemResult.code,
            name: itemResult.description,
          });
        });

        // set data detail workFlow yang akan di tampilkan pada ui
        productTCDetail.map((itemResult) => {
          columnRight.push({
            id: itemResult.productWorkflowProcess.code,
            name: itemResult.productWorkflowProcess.description,
            workFlowSeq: itemResult.workFlowSeq,
            flagData: itemResult.flagData,
            status: itemResult.status,
          });
        });

        // Kolom awal
        const columnLeftObj = { "Available LOS Process": [...columnLeft] };

        // Kolom akhir jika columnRight.length > 0
        const columnRightObj = {
          "Process Workflow": [
            ...columnRight.sort((a, b) => a.workFlowSeq - b.workFlowSeq),
          ],
        };

        // Gabungkan kolom-kolom yang tersedia
        const column = { ...columnLeftObj, ...columnRightObj };

        // menentukan nilai status dan flagData
        const rtun = {
          column,
          status:
            column["Process Workflow"].length > 0
              ? column["Process Workflow"][0].status
              : "inactive",
          flagData:
            column["Process Workflow"].length > 0
              ? column["Process Workflow"][0].flagData
              : "return",
        };

        return rtun;
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const masterTc = createSlice({
  name: "WorkflowProcess",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    positionDND: (state, action) => {
      state.source = action.payload.source;
      state.destination = action.payload.destination;
    },
    ModifyWorkflowList: (state, action) => {
      if (action.payload) {
        state.workflowList = action.payload;
      }
    },
    SeetStatusFlagData: (state, action) => {
      const productWorkflowItems = action.payload.data.productWorkflowItems;

      if (productWorkflowItems.length > 0) {
        state.status = productWorkflowItems[0].status;
        state.flagData = productWorkflowItems[0].flagData;
      }
    },
  },

  extraReducers: (builder) => {
    builder

      //detail
      .addCase(getWorkflowProcessList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getWorkflowProcessList.fulfilled, (state, action) => {
        state.loading = false;
        state.workflowProcessList = action.payload;
      })
      .addCase(getWorkflowProcessList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.workflowList = undefined;
        state.showMessage = true;
      })
      //list
      .addCase(lisWorkflow.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(lisWorkflow.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.workflowList = action.payload.column;
          state.workflowListOrigin = action.payload.column;
          state.status = action.payload.status;
          state.flagData = action.payload.flagData;
        }
      })
      .addCase(lisWorkflow.rejected, (state, action) => {
        state.result = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      //add
      .addCase(addWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "inactive";
        state.flagData = "InApproval";
      })
      .addCase(addWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Do Return
      .addCase(doReturnWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(doReturnWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "inactive";
        state.flagData = "Return";
      })
      .addCase(doReturnWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Reject
      .addCase(rejectWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(rejectWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        if (state.flagData === "UnSuspend" && state.status === "suspended") {
          state.status = "suspended";
          state.flagData = "Approved";
        } else if (state.flagData === "Suspend" && state.status === "active") {
          state.status = "active";
          state.flagData = "Approved";
        }
      })
      .addCase(rejectWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Edit
      .addCase(editWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(editWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "inactive";
        state.flagData = "InApproval";
      })
      .addCase(editWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Delete
      .addCase(deleteWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(deleteWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "inactive";
        state.flagData = "Return";
      })
      .addCase(deleteWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Approve
      .addCase(approveWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(approveWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        if (state.flagData === "Suspend" && state.status === "active") {
          state.status = "suspended";
          state.flagData = "Approved";
        } else if (
          state.flagData === "UnSuspend" &&
          state.status === "suspended"
        ) {
          state.status = "active";
          state.flagData = "Approved";
        } else if (
          state.flagData === "InApproval" &&
          state.status === "inactive"
        ) {
          state.status = "active";
          state.flagData = "Approved";
        }
      })
      .addCase(approveWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //Request
      .addCase(requestWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(requestWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "active";
        state.flagData = "Suspend";
      })
      .addCase(requestWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // UnSuspand
      .addCase(usSuspandWorkflowProcess.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(usSuspandWorkflowProcess.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "suspended";
        state.flagData = "UnSuspend";
      })
      .addCase(usSuspandWorkflowProcess.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  ModifyWorkflowList,
  positionDND,
  SeetStatusFlagData,
} = masterTc.actions;

export default masterTc.reducer;
